import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import { Loading } from "components";
import { PublicLayout } from "containers";
import { LabAnalysisInfo } from "./Lab/LabAnalysisInfo/LabAnalysisInfo";
// import Technology from "./Technology";

const Services = React.lazy(() => import("views/public/Services"));
const Service = React.lazy(() => import("views/public/Service"));
const Doctors = React.lazy(() => import("views/public/Doctors"));
const Main = React.lazy(() => import("views/public/Main"));
const Branches = React.lazy(() => import("views/public/Branches"));
const Branch = React.lazy(() => import("views/public/Branch"));
const Laboratory = React.lazy(() => import("views/public/Laboratory"));
const Lab = React.lazy(() => import("views/public/Lab"));
const Analysis = React.lazy(() => import("views/public/Analysis"));
const News = React.lazy(() => import("views/public/News"));
const Blog = React.lazy(() => import("views/public/Blog"));
const AboutUs = React.lazy(() => import("views/public/AboutUs"));
const Promotions = React.lazy(() => import("views/public/Promotions"));
const Gallery = React.lazy(() => import("views/public/Gallery"));
const Vacancies = React.lazy(() => import("views/public/Vacancies"));
const Vacancy = React.lazy(() => import("views/public/Vacancy"));
const AfterGraduate = React.lazy(() => import("views/public/AfterGraduate"));
const CovidQuestions = React.lazy(() => import("views/public/CovidQuestions"));
const TermsAndConditions = React.lazy(() => import("views/public/TermsAndConditions"));
const SearchResults = React.lazy(() => import("views/public/SearchResults"));
const Contact = React.lazy(() => import("views/public/Contact"));
const PersonalData = React.lazy(() => import("views/public/PersonalData"));
const ContactAudit = React.lazy(() => import("views/public/ContactAudit"));
const Partners = React.lazy(() => import("views/public/Partners"));
const HealthCheck = React.lazy(() => import("views/public/HealthCheck"));
const HealthCheckDetail = React.lazy(() => import("views/public/HealthCheckDetail"));
const ResponseMessagePage = React.lazy(() => import("components/ResponseMessagePage"));
const LaboratoryAnalysis = React.lazy(() => import("views/public/LaboratoryAnalysis"));
const LabAnalysis = React.lazy(() => import("views/public/LabAnalysis"));
const Technology = React.lazy(() => import("views/public/Technology"));
const NotFound = React.lazy(() => import("views/public/404"));
const DiplomaStudy = React.lazy(() => import("views/public/DiplomaStudy"));

export function PublicRoutes() {
  const location = useLocation();

  const authStep =
    location?.pathname?.includes("/login") ||
    location?.pathname?.includes("/registration") ||
    location?.pathname?.includes("/reset-password") ||
    location?.pathname?.includes("/complete-reset-password-initial");

  // 🔁 Route structure reused for both / and /:lang
  const routeTree = (
    <Route path="" element={<PublicLayout />}>
        {!authStep && <Route index element={<Main />} />}
      <Route path="services" element={<Services />} />
      <Route path="services/:id" element={<Service />} />
      <Route path="diploma" element={<DiplomaStudy />} />
      <Route path="doctors/:page/*" element={<Doctors />} />
      <Route path="doctors" element={<Doctors />} />
      <Route path="branches" element={<Branches />} />
      <Route path="branches/:page/*" element={<Branches />} />
      <Route path="branches/:page/branch/:id" element={<Branch />} />
      <Route path="news" element={<News />} />
      <Route path="news/:page/*" element={<News />} />
      <Route path="blog" element={<Blog />} />
      <Route path="blog/:page/*" element={<Blog />} />
      <Route path="about-us" element={<AboutUs />} />
      <Route path="promotions" element={<Promotions />} />
      <Route path="promotions/:page/*" element={<Promotions />} />
      <Route path="gallery" element={<Gallery />} />
      <Route path="gallery/:page/*" element={<Gallery />} />
      <Route path="vacancies" element={<Vacancies />} />
      <Route path="vacancies/:id/:slug" element={<Vacancy />} />
      <Route path="partners" element={<Partners />} />
      <Route path="health-check" element={<HealthCheck />} />
      <Route path="health-check/:id" element={<HealthCheckDetail />} />
      <Route path="health-check/:id/:status/:service" element={<ResponseMessagePage />} />
      <Route path="after-graduate" element={<AfterGraduate />} />
      <Route path="covid" element={<CovidQuestions />} />
      <Route path="terms" element={<TermsAndConditions />} />
      <Route path="search-results" element={<SearchResults />} />
      <Route path="search-results/:page" element={<SearchResults />} />
      <Route path="contact" element={<Contact />} />
      <Route path="personal-data" element={<PersonalData />} />
      <Route path="contact-audit" element={<ContactAudit />} />
      <Route path="laboratory/*" element={<Laboratory />} />
      <Route path="lab/*" element={<Lab />} />
      <Route path="lab/analysis" element={<Analysis />} />
      <Route path="lab/analysis/:id" element={<LabAnalysisInfo />} />
      <Route path="laboratory-analysis/:id" element={<LaboratoryAnalysis />} />
      <Route path="technology/:slug" element={<Technology />} />
      {!location?.pathname?.includes("pr-") && !authStep && (
        <Route path="*" element={<NotFound />} />
      )}
    </Route>
  );

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Georgian (default) */}
        <Route path="/" element={<PublicLayout />}>
          {routeTree.props.children}
        </Route>

        {/* English, Russian (or other future prefixes) */}
        <Route path="/:lang" element={<PublicLayout />}>
          {routeTree.props.children}
        </Route>
      </Routes>
    </Suspense>
  );
}
